import React from "react"
import Fade from "react-reveal/Fade"
import "./banner.css"
import Typical from "react-typical"
import { Button } from "../button-elements"
import { Row, Col } from "antd"
import { FaAngleDoubleDown } from "@react-icons/all-files/fa/FaAngleDoubleDown"
import TweenOne from "rc-tween-one"
import mohitCV from "../../content/Mohit-FullStack-JavaScript.pdf"

const devname = [
  "Hi!, { iAMohit }",
  5000,
  "Hi!, { ...iAMohit }",
  2500,
  "Hi!, i am Mohit",
  5000,
  "Hi!, I'm Mohit",
  2000,
]
const subtitles = [
  "I'm a Software Engineering Manager",
  2500,
  "I'm a Coach / Mentor",
  3500,
  "I'm a Solution Architect",
  4500,
  "I'm a Frontend Expert",
  3500,
  "I'm into Reality (AR / VR / XR)",
  2500,
  "I'm advocating AWS Amplify",
  3500,
  "I can do hands on Coding / Programming",
  4500,
]
const Banner = () => {
  return (
    <Row className="banner jumbotron">
      <Col span={24} className="banner-container">
        <Fade bottom big delay={20}>
          <Typical
            steps={devname}
            className="devNames"
            loop={Infinity}
            wrapper="p"
          />
        </Fade>
        <Fade right big delay={40}>
          <Typical
            steps={subtitles}
            className="subTitles"
            loop={Infinity}
            wrapper="p"
          />
        </Fade>

        <Fade left duration={500} delay={1000}>
          <div style={{ marginTop: 40, padding: 40 }}>
            <a href={mohitCV} download>
              <Button fontBig big primary>
                Download CV
              </Button>
            </a>
          </div>
        </Fade>
        <TweenOne
          animation={{
            y: 70,
            repeat: -1,
            duration: 1000,
            scale: 1.5,
            ease: "easeOutBounce",
          }}
        >
          <FaAngleDoubleDown style={{ fontSize: 30, color: "#f5f543" }} />
        </TweenOne>
      </Col>
    </Row>
  )
}

export default Banner
